var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconHomeArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 10,
  viewBox: "0 0 15 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.1405 0.532227L7.5 5.77752L12.859 0.532227L14.5 2.14605L7.5 9.03223L0.5 2.14605L2.1405 0.532227Z",
  fill: "#4585FF"
})));
export default SvgIconHomeArrow;